import { PillGroup } from '@homex/se-react-components';
import { CarouselItemId } from '@homex/se-widget-flow-types';
import React from 'react';
import { useSelector } from 'react-redux';

import { setIsEmergency } from 'actions';
import { CarouselContinueButton } from 'components/CarouselContinueButton';
import { Phrase } from 'components/Phrase';
import { useThunkDispatch } from 'hooks/useThunkDispatch';
import { IState } from 'typings';

import { FormGroup, HvacBrokenStyled } from './styles';

enum ScheduleEmergencyOption {
  NO = 'NO',
  YES = 'YES',
}

export const CarouselItemScheduleEmergencyBottom = () => {
  const dispatch = useThunkDispatch();
  const { isEmergency } = useSelector((state: IState) => ({
    isEmergency: state.userInput.isEmergency,
  }));

  const options = [
    {
      key: ScheduleEmergencyOption.NO,
      label: Phrase({ id: 'SCHEDULE_EMERGENCY.NO.LABEL' }),
      value: ScheduleEmergencyOption.NO,
    },
    {
      key: ScheduleEmergencyOption.YES,
      label: Phrase({ id: 'SCHEDULE_EMERGENCY.YES.LABEL' }),
      value: ScheduleEmergencyOption.YES,
    },
  ];
  const value = isEmergency
    ? ScheduleEmergencyOption.YES
    : ScheduleEmergencyOption.NO;

  const handleChange = (event: React.FormEvent<HTMLInputElement>) => {
    dispatch(
      setIsEmergency(event.currentTarget.value === ScheduleEmergencyOption.YES),
    );
  };

  return (
    <FormGroup>
      <div>
        <HvacBrokenStyled />
        <PillGroup
          onChange={handleChange}
          options={options}
          title={Phrase({ id: 'SCHEDULE_EMERGENCY.LEGEND' })}
          value={value}
        />
      </div>
      <CarouselContinueButton
        destinationItemId={CarouselItemId.SchedulePreferenceSales}
      />
    </FormGroup>
  );
};
